const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Track Inner Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Tracks} Tracks the resource defined to manage Tracks
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('trackInnerViewer', ['Application', 'Authorization', 'Analyze', 'TrackOrganization', 'UserTracks', '$location', 'ContentAuth', 'Content', '$translate','ConfettiGenerator', function (Application, Authorization, Analyze, TrackOrganization, UserTracks, $location, ContentAuth, Content, $translate, ConfettiGenerator) {
  return {
    restrict: 'E',
    scope: {
      journeyId: '=?',
      contentId: '=?',
      trackId: '=?',
      journeyInnerNav: '&?'
    },
    template: require('../../templates/directives/track-inner-viewer.html'),
    controller: ['$scope', '$timeout', function ($scope, $timeout) {
      var self = this;
      self.triggerRating = false;
      self.ratingTriggered = false;
      self.inJourney = !!$scope.journeyId;
      self.user = Authorization.getAuthToken().user;
      self.params = Application.navigation.getRouteParameters();
      self.trackId = $scope.trackId || Application.navigation.getRouteParameters().trackId;
      if (self.trackId && self.trackId.indexOf('?')) {
        self.trackId = self.trackId.split('?')[0];
      }
      self.inJourney = !!$scope.journeyId;
      var previousPage = Application.navigation.history.length - 2;
      self.tracking = new Application.Tracking(Analyze, moment, 'track');
      self.trackFirstComplete = false;
      self.xOut = Application.navigation.history.length === 1 ? 0 : Application.navigation.history.length - 2;
      var completionSets = ['completed_articles', 'completed_media', 'completed_quizzes', 'completed_assessments', 'completed_scorm'];

      self.progression = {
        percent: 0,
        completedCourses: 0,
        totalCourses: 0,
        courseList: [],
        updateProgress: function() {
          var courses = [].concat(self.progression.courseList);
          var completed = 0;
          completionSets.forEach(function(item) {
            if (self.originalUserTrack[item] && self.originalUserTrack[item].length) {
              self.originalUserTrack[item].forEach(function(course) {
                var index = courses.indexOf(course);
                if (index !== -1) {
                  completed++;
                  courses.splice(index, 1);
                }
              });
            }
          });

          self.progression.completedCourses = completed;
          var percent = Math.round(completed / self.progression.totalCourses * 100);
          self.progression.percent = percent < 0 ? 0 : percent > 100 ? 100 : percent;
        },
        getPercent: function() {
          return {width: self.progression.percent + '%'};
        }
      };

      self.markupReference = {
        resource: false,
        initialComplete: false,
        initialReady: true,
        allowScorm: true,
        sidebarOpen: false,
        discussionOpen: false,
        showCompleteState: false,
        showCertificate: false,
        closeCertificate: function() {
          self.markupReference.showCertificate = false;
          if (self.inJourney) {
            $scope.journeyInnerNav();
            return;
          }
          if (self.originalTrack.surveys.length) {
            self.showSurveyPopup = true;
          }
          if (!self.ratingTriggered) {
            self.triggerRating = true;
            self.ratingTriggered = true;
            var watchRating = $scope.$watch('viewer.triggerRating', function(newVal, oldVal) {
              if (!newVal) {
                watchRating();
                Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
              }
            });
            return;
          }

          Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
        },
        activeContent: {},
        scormIgnore: false,
        commentsClick: function() {
          self.markupReference.discussionOpen = true;
        },
        lastCourse: null,
        resetSidebarNav: function () {
          Object.keys(self.markupReference).forEach(function(key) {
            if (key.indexOf('section-') !== -1) {
              delete self.markupReference[key];
            }
          });

          self.markupReference['section-' + self.navigation.currentSection] = true;
        }
      };

      self.navigation = {
        previousAvailable: false,
        currentSection: null,
        currentCourse: null,
        completedSections: {},
        setSectionCompletion: function(track, userTrack) {
          self.completedSections = {};
          if (!track || !track.sections || !track.sections.length || !userTrack) {
            return;
          }
          var completions = [].concat((userTrack.completed_articles || []), (userTrack.completed_media || []), (userTrack.completed_quizzes || []), (userTrack.completed_scorm || []), (userTrack.completed_assessments || []));

          track.sections.forEach(function(section, index) {
            if (!section || !section.courses || !section.courses.length) {
              return;
            }

            var courses = section.courses.map(function(item) {
              return item.article || item.file || item.video || item.media || item.quiz || item.scorm || item.assessment || null;
            });

            courses = courses.map(function(item) {
              return item && item._id || null;
            });

            var completed = true;

            for (var i = 0; i < courses.length; i++) {
              if (completions.indexOf(courses[i]) === -1) {
                completed = false;
              }
            }

            self.navigation.completedSections[section.position - 1] = completed;
          });
        },
        checkNextAvailable: function() {
          if (!self.originalTrack) {
            return false;
          }
          if ((!self.originalTrack.sequential || self.originalTrack.resource) && (!self.originalTrack.lock_scorm || self.markupReference.activeContent.type !== 'scorm' || self.markupReference.activeContent.completed)) {
              return true;
          }
          // current item must be completed
          if (!self.markupReference.activeContent || !self.markupReference.activeContent.completed) {
            return false;
          }
          var track = self.organizedTrack.track;
          var item = track[this.currentSection][this.currentCourse + 1] || track[this.currentSection + 1] && track[this.currentSection + 1][0];
          // if no item, last course is assumed
          if (!item || item && item.available) {
            return true;
          }
          return false;
        },
        goTo: function(id, initial) {
          if (!self.originalTrack.resource && self.markupReference.initialComplete) {
            self.markupReference.initialComplete = false;
            if (self.originalTrack.certificate) {
              self.markupReference.completedDate = self.originalUserTrack && self.originalUserTrack.completedDate || new Date();
              self.markupReference.showCertificate = true;
              self.organizedTrack.viewedCertificate();
              return;
            }
            if (self.originalTrack.surveys.length) {
              self.showSurveyPopup = true;
            }
            self.triggerRating = true;
            self.ratingTriggered = true;
            self.markupReference.showCompleteState = true;
            return;
          }
          // find previous id if available
          if (id === 'previous' && this.currentSection !== null && this.currentCourse !== null) {
            var track = self.organizedTrack.track;
            // set id equal to previous course in section or null
            id = this.currentCourse > 0 && track[this.currentSection].courses[this.currentCourse - 1] && track[this.currentSection].courses[this.currentCourse - 1].type && track[this.currentSection].courses[this.currentCourse - 1][track[this.currentSection].courses[this.currentCourse - 1].type]._id;
            // set id equal to last course in previous section or null
            const prevSection = track[this.currentSection - 1];
            const prevCourses = track[this.currentSection - 1]?.courses;
            const prevCourse = prevCourses?.length && prevCourses[prevCourses?.length - 1];
            id = id || this.currentSection > 0 && prevSection && prevCourse && prevCourse.type && prevCourse[prevCourse.type]._id;
          }

          // find next available course if no id provided
          if (!id && this.currentSection !== null && this.currentCourse !== null) {
            var track = self.organizedTrack.track;
            // set id equal to next course in section or null
            id = track[this.currentSection].courses[this.currentCourse + 1] && track[this.currentSection].courses[this.currentCourse + 1].type && track[this.currentSection].courses[this.currentCourse + 1][track[this.currentSection].courses[this.currentCourse + 1].type]._id;
            // set id equal to first course in next section or null
            id = id || track[this.currentSection + 1] && track[this.currentSection + 1].courses[0] && track[this.currentSection + 1].courses[0].type && track[this.currentSection + 1].courses[0][track[this.currentSection + 1].courses[0].type]._id;
          }

          if (!id && self.inJourney) {
            $scope.journeyInnerNav();
            return;
          }

          // If still no id exists - return to the overview page
          if (!id) {
            Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
            return;
          }

          // get track position of requested course
          var coordinates = self.organizedTrack.navigate(id.toString());
          if (coordinates.status !== 'success') {
            Application.messaging.addMessage({type: 'error', duration: 6, text: coordinates.reason});
            return;
          }
          // Verify positions and ids
          var item = self.organizedTrack.track && self.organizedTrack.track[coordinates.sectionIndex] && self.organizedTrack.track[coordinates.sectionIndex].courses && self.organizedTrack.track[coordinates.sectionIndex].courses[coordinates.courseIndex];
          if (!item || !item.type || !item[item.type]._id || item[item.type]._id.toString() !== id.toString()) {
            Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['trackinnerviewer.internal_error']});
            return;
          }

          self.markupReference.scormIgnore = self.markupReference.activeContent && self.markupReference.activeContent.scorm && self.markupReference.activeContent.scorm._id || false;
          self.markupReference.scormLoading = true;
          self.markupReference.allowScorm = false;
          self.navigation.previousAvailable = coordinates.sectionIndex === 0 && coordinates.courseIndex === 0 ? false : true;
          self.navigation.currentSection = coordinates.sectionIndex;
          self.navigation.currentCourse = coordinates.courseIndex;
          self.navigation.checkNextAvailable();
          // set active item and update link address
          self.markupReference.activeContent = item;
          UserTracks.lastview({subresource: self.originalUserTrack._id, contentId: self.markupReference.activeContent[self.markupReference.activeContent.type]._id}, null);
          self.markupReference.resume = self.markupReference.activeContent[self.markupReference.activeContent.type]._id;
          setTimeout(function() {
            self.markupReference.allowScorm = true;
            $scope.$apply();
          }, 1);

          if (initial) {
            self.markupReference['section-' + coordinates.sectionIndex] = true;
            self.markupReference.initialReady = true;
            return;
          }

          if (self.inJourney) {
            $scope.journeyInnerNav({id: id});
            return;
          }

          $location.path(item.link);
          Authorization.setActive();
        },
        completeItem: function() {
          if (!self.markupReference.activeContent) {
            return;
          }

          self.organizedTrack.completeItem(self.markupReference.activeContent)
          .then(function(result) {
            if (result.status === 'track completed') {
              // handle track completion
              const completionContexts = [];
              if (!self.markupReference.initialComplete) {
                self.markupReference.initialComplete = true;
              }
              if (self.inJourney) {
                completionContexts.push({key: 'journey', value: $scope.journeyId});
              }
              Content.complete({
                type: 'track', 
                id: self.originalTrack._id,
                contexts: completionContexts
              });
              
            }
            self.originalUserTrack = self.organizedTrack.originalUserTrack;
            self.navigation.setSectionCompletion(self.originalTrack, self.originalUserTrack);
            self.progression.updateProgress();
            self.navigation.checkNextAvailable();
          }).catch(function(error) {
            // handle various errors
            console.log('error in complete content: ', error);
          });

        },
        scormExit: function(id) {
          if (self.markupReference.scormIgnore && id && self.markupReference.scormIgnore === id) {
            self.markupReference.scormIgnore = false;
            return;
          }

          self.markupReference.scormIgnore = false;
          // Delays are necessary do to lag in info from jca
          if (self.navigation.checkNextAvailable()) {
            setTimeout(function() {
              if (id && Application.navigation.getPath().indexOf(id) === -1) {
                return;
              }
              self.navigation.goTo();
              $scope.$apply();
            }, 1);
            return;
          }
          // if Next is not available go to the main track page.
          setTimeout(function() {
            if (self.inJourney) {
              $scope.journeyInnerNav();
              return;
            }
            if (id && Application.navigation.getPath().indexOf(id) === -1) {
              return;
            }

            Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
            $scope.$apply();
          }, 1);
        },
        sideBarTitle: function() {
          if (self.inJourney) {
            $scope.journeyInnerNav();
            return;
          }
          Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
        }
      };

      self.initialize = function() {
        if (!self.trackId) {
          console.log('No id specified');
          Application.navigation.goToHome();
          return;
        }

        self.loadingTrack = true;
        self.organizedTrack = new TrackOrganization.OrganizedTrack(self.trackId, self.user._id, {}, true);

        self.organizedTrack.initialize()
        .then(function() {
          self.originalTrack = self.organizedTrack.originalTrack;
          self.markupReference.resource = self.originalTrack.resource;
          self.originalUserTrack = self.organizedTrack.originalUserTrack;
          self.progression.courseList = Object.keys(self.organizedTrack.contentDirectory);
          self.progression.totalCourses = self.progression.courseList.length;
          self.progression.updateProgress();
          var lastSection = self.organizedTrack.track[self.organizedTrack.track.length - 1];
          var lastCourse = lastSection.courses[lastSection.courses.length - 1];
          self.markupReference.lastCourse = lastCourse;
          if (!self.originalUserTrack || !self.originalUserTrack._id) {
            if (self.inJourney) {
              $scope.journeyInnerNav();
              return;
            }
            Application.storage.put('immediateTrack', self.params.id);
            Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
            return 'nout';
          }
          self.navigation.setSectionCompletion(self.originalTrack, self.originalUserTrack);
          return ContentAuth.allowView(self.originalTrack);
        }).then(function(allowed) {
          if (allowed === 'nout') {
            return;
          }
          if (!allowed) {
            Application.messaging.addMessage({type: 'error', text: self.translations['trackinnerviewer.error_permission'], duration: 5});
            Application.navigation.back();
            return;
          }
          if (self.originalUserTrack && self.originalUserTrack.completed_date) {
            self.triggerRating = true;
            self.ratingTriggered = true;
          }
          Analyze.record({resource: 'views'}, {content: self.originalTrack._id, content_type: 'track'});
          Application.analyticsProvider.trackEvent('track_viewed', {content: self.originalTrack._id, content_type: 'track', title: self.originalTrack.title});
          self.tracking.start(self.originalTrack);
          var url = Application.navigation.getUrl();
          let contentId = $scope.contentId || url.split('/').pop();
          if (contentId && contentId.indexOf('?')) {
            contentId = contentId.split('?')[0];
          }
          if (!contentId) {
            if (self.inJourney) {
              Application.messaging.addMessage({type: 'error', text: self.translations['trackinnerviewer.not_valid_content'], duration: 5});
              $scope.journeyInnerNav();
              return;
            }
            Application.messaging.addMessage({type: 'error', text: self.translations['trackinnerviewer.not_valid_content'], duration: 5});
            Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
            return;
          }
          self.navigation.goTo(contentId, true);
          self.loadingTrack = false;
        });
      };

      $scope.$on('$destroy', function() {
        self.tracking.end();
      });

      $translate([
        'trackinnerviewer.internal_error',
        'trackinnerviewer.error_permission',
        'trackinnerviewer.not_valid_content'
      ]).then(function (translations) {
        self.translations = translations;
        self.initialize();
      });

      var confettiSettings = { target: 'my-canvas',"max":"80","size":"2","animate":true,"props":["circle","square","triangle","line"],"colors":[[165,104,246],[230,61,135],[0,199,228],[253,214,126]],"clock":"25","rotate":true,"start_from_edge":true,"respawn":false};
      self.fireConfetti = function() {
        $timeout(function () {
          self.markupReference.showCompleteState = false;
          if (self.inJourney) {
            $scope.journeyInnerNav();
            return;
          }
          Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
        }, 5000);
        (function(){
           var confetti = new ConfettiGenerator(confettiSettings);
           confetti.render();
        })();
      };

    }],
    controllerAs: 'viewInner'
  };
}]);
